import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { WebsiteChromeService } from './website-chrome.service';

export const storyblokHeaderResolver = (route: ActivatedRouteSnapshot) => {
  return inject(WebsiteChromeService).header(route);
};
